// Mock data for pulse-chat

export const mockGeneratedImages = [
  {
    id: '1',
    prompt: 'A serene mountain landscape at sunset with golden light',
    imageUrl: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80',
    size: 'landscape',
    createdAt: new Date().toISOString(),
    type: 'text-to-image'
  },
  {
    id: '2',
    prompt: 'Futuristic cityscape with neon lights and flying cars',
    imageUrl: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=800&q=80',
    size: 'square',
    createdAt: new Date().toISOString(),
    type: 'text-to-image'
  },
  {
    id: '3',
    prompt: 'Portrait of a woman with elegant fashion style',
    imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800&q=80',
    size: 'portrait',
    createdAt: new Date().toISOString(),
    type: 'image-to-image'
  }
];

export const mockGeneratedVideos = [
  {
    id: '1',
    prompt: 'Cinematic shot of ocean waves crashing on rocks',
    thumbnailUrl: 'https://images.unsplash.com/photo-1505142468610-359e7d316be0?w=800&q=80',
    duration: '5s',
    createdAt: new Date().toISOString(),
    type: 'text-to-video'
  },
  {
    id: '2',
    prompt: 'Time-lapse of city traffic at night',
    thumbnailUrl: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800&q=80',
    duration: '10s',
    createdAt: new Date().toISOString(),
    type: 'image-to-video'
  }
];

export const brandLogos = [
  { name: 'Microsoft', opacity: 0.6 },
  { name: 'Google', opacity: 0.6 },
  { name: 'Apple', opacity: 0.6 },
  { name: 'Amazon', opacity: 0.6 },
  { name: 'Meta', opacity: 0.6 },
  { name: 'Netflix', opacity: 0.6 }
];